import request from "superagent";

export const getRecentViewedVideo = ({ params }) =>
  request.post("/api/public/elasticsearch/recentviews-*/_search").send(params);
export const sentLogEvent = ({ params }) =>
  request.post("/api/public/logstash/").send(params);
export const getVideoDetails = (ids) =>
  request.get(`/api/public/videos/data?ids=[${ids}]`);
